export type { OrgConfigGetResponseDTO } from './modules/v1/credentials/dto/org-config-credentials.get.response.dto';
export type { OrgConfigUpsertBodyDTO } from './modules/v1/credentials/dto/org-config-credentials.upsert.body.dto';

// Tipos específicos para a interface do mapeamento
export interface AliareFieldMapping {
  aliareField: string;
  customerUnitField?: string;
  customerGroupField?: string;
  transformer?: string;
  isFixedField: boolean;
  fixedValue?: string;
  description?: string;
}

export interface CustomField {
  id: string;
  name: string;
  identifier: string;
  type: string;
}

export interface OrgSetupCustomField {
  id: string;
  identifier: string;
  entity: string;
  label: string;
  customFieldGroupId: string | null;
  fieldType: string;
  isRequired: boolean;
  isEditable: boolean;
  description: string;
  components: {
    nodes: Array<{
      label: string;
      value: string;
    }>;
  } | null;
  config: object | null;
}

export const FIXED_ALIARE_FIELDS: Record<string, string> = {
  endereco: 'endereco',
  telefone: 'telefone',
  email: 'email',
  cpfCnpj: 'cpfCnpj',
  razaoSocial: 'razaoSocial',
  nomeFantasia: 'nomeFantasia',
  emailVendedor: 'emailVendedor',
};

export const AVAILABLE_ALIARE_FIELDS = [
  'codigo',
  'pessoa',
  'razaoSocial',
  'nomeFantasia',
  'tipoPessoa',
  'cpfCnpj',
  'rgInscricaoEstadual',
  'orgaoEmissor',
  'inscricaoMunicipal',
  'dataRgInscricaoEstadual',
  'sexo',
  'dataCadastro',
  'endereco',
  'numero',
  'bairro',
  'cep',
  'municipio',
  'telefone',
  'celular',
  'fax',
  'email',
  'cliente',
  'fornecedor',
  'transportador',
  'longitude',
  'latitude',
  'dataInsercao',
  'dataManutencao',
  'dataSincronizacao',
  'tipoContribuinte',
  'site',
  'observacao',
  'situacao',
  'idEstrangeiro',
  'funruralSENAR',
  'codigoCND',
  'autenticacaoCND',
  'validadeCND',
  'tipoContribuinteIPI',
  'tipoContribuintePisCofins',
  'emailVendedor',
  'gestorResponsavel',
  'filial',
];
